import {
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl
} from '@mui/material'
import React, { useCallback } from 'react'
import { useFormik } from 'formik'
import { RefreshActions } from '../state/refresh'
import { useDispatch, useSelector } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { State } from '../types/state'
import { useIsMobileView } from '../hooks/useIsMobileView'
import { AppState, SelectionStatus, Visibility } from '../types/app-state'
import { ErrorAlert } from '../formik/ErrorAlert'

const ConfigurationPanel = (): JSX.Element => {
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView()
  const requestMaker = useRequests()
  const appState = useSelector((state: State) => state.user.app)

  const validate = (app: Partial<AppState>): Partial<AppState> => {
    const errors: typeof app = {}

    if (!app.visibility) {
      errors.visibility = 'Choose visiility' as any
    }

    if (!app.selectionStatus) {
      errors.selectionStatus = 'Choose selection status' as any
    }

    if (!app.standardLevelSubjectNumber) {
      errors.standardLevelSubjectNumber =
        'Number of SL sbjects cannot be empty' as any
    }

    if (!app.highLevelSubjectNumber) {
      errors.highLevelSubjectNumber =
        'Number of HL sbjects cannot be empty' as any
    }

    return errors
  }

  const onSubmit = useCallback(
    async (appState: AppState): Promise<void> => {
      try {
        await requestMaker.updateAppState({
          selectionStatus: appState.selectionStatus,
          visibility:
            appState.visibility === Visibility.VISIBLE
              ? Visibility.VISIBLE
              : Visibility.NOT_VISIBLE,
          highLevelSubjectNumber: appState.highLevelSubjectNumber,
          standardLevelSubjectNumber: appState.standardLevelSubjectNumber
        })
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Succesfully updated app details'
          })
        )
        dispatch(RefreshActions.refreshUserState())
      } catch (e) {
        dispatch(
          RefreshActions.setToastMessage({
            message:
              'Error - fill all neccessary fields correctly and try again'
          })
        )
      }
    },
    [requestMaker, dispatch]
  )

  const formik = useFormik({
    initialValues: {
      ...appState,
      visibility:
        appState?.visibility === Visibility.VISIBLE
          ? Visibility.VISIBLE
          : ('NOT_VISIBLE' as any)
    } as any,
    onSubmit,
    enableReinitialize: true,
    validate
  })

  return (
    <form>
      <div style={{ width: isMobileView ? '80vw' : '40vw', margin: 'auto' }}>
        <DialogTitle>Configuration</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{ marginTop: '1vw' }}>
            <InputLabel id='selectionStatus'>Selection status</InputLabel>
            <Select
              labelId='selectionStatus'
              id='selectionStatus'
              value={formik.values.selectionStatus}
              label='Selection Status'
              onChange={e =>
                void formik.setFieldValue('selectionStatus', e.target.value)}
            >
              {Object.keys(SelectionStatus)?.map((r, index) => (
                <MenuItem key={index} value={r}>
                  {r}
                </MenuItem>
              ))}
            </Select>
            <ErrorAlert formik={formik} name='selectionStatus' />
          </FormControl>
          <FormControl fullWidth style={{ marginTop: '1vw' }}>
            <InputLabel id='visibility'>Visibility</InputLabel>
            <Select
              labelId='visibility'
              id='visibility'
              value={formik.values.visibility}
              label='Visibility'
              onChange={e =>
                void formik.setFieldValue('visibility', e.target.value)}
            >
              {Object.keys(Visibility)?.map((r, index) => (
                <MenuItem key={index} value={r}>
                  {r}
                </MenuItem>
              ))}
            </Select>
            <ErrorAlert formik={formik} name='visibility' />
          </FormControl>
          <TextField
            error={
              formik.errors.standardLevelSubjectNumber !== undefined &&
              formik.touched.standardLevelSubjectNumber
            }
            variant='filled'
            helperText={
              formik.touched.standardLevelSubjectNumber &&
              formik.errors.standardLevelSubjectNumber
                ? formik.errors.standardLevelSubjectNumber
                : null
            }
            value={formik.values.standardLevelSubjectNumber}
            onChange={formik.handleChange}
            margin='normal'
            fullWidth
            id='standardLevelSubjectNumber'
            label='Number of SL Subjects'
            name='standardLevelSubjectNumber'
            autoComplete='standardLevelSubjectNumber'
            type='number'
          />
          <TextField
            error={
              formik.errors.highLevelSubjectNumber !== undefined &&
              formik.touched.highLevelSubjectNumber
            }
            variant='filled'
            helperText={
              formik.touched.highLevelSubjectNumber &&
              formik.errors.highLevelSubjectNumber
                ? formik.errors.highLevelSubjectNumber
                : null
            }
            value={formik.values.highLevelSubjectNumber}
            onChange={formik.handleChange}
            margin='normal'
            fullWidth
            id='highLevelSubjectNumber'
            label='Number of HL Subjects'
            name='highLevelSubjectNumber'
            autoComplete='highLevelSubjectNumber'
            type='number'
          />
        </DialogContent>
      </div>

      <DialogActions>
        <Button
          onClick={formik.handleSubmit as any}
          style={{ margin: 'auto' }}
          variant='contained'
        >
          Update
        </Button>
      </DialogActions>
    </form>
  )
}

export default ConfigurationPanel
